<div class="input-group">
  <input class="form-control {{ styleClass }}"
    [class.is-invalid]="(isInvalidAndInteracted || styleClass === 'is-invalid') && !disabled" [disabled]="disabled"
    type="text" [placeholder]="placeHolderValue" [ngModel]="displayValue" (ngModelChange)="displayValueChanged($event)"
    (selectItem)="selectItem($event)" [ngbTypeahead]="search" [minLength]="minimumSearchLength"
    [resultFormatter]="formatter" [resultTemplate]="resultTemplate" [inputFormatter]="inputFormatter"
    [editable]="vrijeInvulMogelijk" (focus)="focus$.next($any($event).target.value)"
    (click)="click$.next($any($event).target.value)" #instance="ngbTypeahead" />
  @if (toonResetKnop && !disabled) {
  <button
    [ngClass]="{ 'btn-outline-secondary': !isInvalidAndInteracted, 'btn-outline-danger text-danger': isInvalidAndInteracted }"
    class="btn" (click)="reset()" type="button">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
      viewBox="0 0 16 16">
      <path
        d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
    </svg>
  </button>
  }
</div>

<ng-template #resultTemplate let-result="result">
  <div class="search-result">
    <span class="search-result__title">{{ result.weergave }}</span>
    @if (result.secondaryText) {
    <span class="search-result__details">{{ result.secondaryText }}</span>
    }
  </div>
</ng-template>